import { useIsReportToolActive } from "@/store/ui/ui-utils";

/**
 * @returns True if the user can change the current active tool
 */
export function useCanChangeTool(): boolean {
  return !useIsReportToolActive();
}
